import { lazy } from "react";

export const SignIn = lazy(() => import("./Auth/SignIn"));
export const CreatePassword = lazy(() => import("./Auth/CreatePassword"));
export const ForgetPassword = lazy(() => import("./Auth/ForgetPassword"));

export const ChangePassword = lazy(() => import("./MyProfile/ChangePassword"));
export const DeleteAccount = lazy(() => import("./MyProfile/DeleteAccount"));
export const Notification = lazy(() => import("./MyProfile/Notification"));
export const Person = lazy(() => import("./MyProfile/Person"));
export const Roles = lazy(() => import("./MyProfile/Roles"));
export const Settings = lazy(() => import("./MyProfile/Settings"));
export { ProfileLayout } from "./MyProfile";

export const Account = lazy(() => import("./MyProfile/Account"));
export const UserPage = lazy(() => import("./Users"));
export const Communities = lazy(() => import("./Communities"));
export const Organizations = lazy(() => import("./Organizations"));
export const Forms = lazy(() => import("./Forms/Directory"));
// export const ConfigureRegions = lazy(
//   () => import("view/components/MapConfigureComponents/SelectComponent")
// );
export const CommunityProfile = lazy(
  () => import("./Communities/communityProfile")
);

export const EditFormDetails = lazy(() => import("./Forms/EditFormDetails"));
export const ProgramProfile = lazy(() => import("./Programs/ProgramProfile"));
export const Programs = lazy(() => import("./Programs"));
export const Files = lazy(() => import("./Files"));
export const Protocols = lazy(() => import("./Protocols"));
export const ProtocolProfile = lazy(
  () => import("./Protocols/ProtocolProfile")
);
export const GeographyMap = lazy(() => import("./Geography/Map"));
export const AdminGeography = lazy(() => import("./Geography"));
export const DataAccessPolicy = lazy(
  () => import("./Programs/DataAccessPolicy")
);
export const Observations = lazy(() => import("./Observations"));
export const Notifications = lazy(() => import("./Notifications"));
export const ObservationProfile = lazy(
  () => import("./Observations/ObservationProfile")
);
export const Management = lazy(() => import("./Manager"));
export const Messages = lazy(() => import("./Messages"));
export const QualityAssurance = lazy(() => import("./QualityAssurance"));
export const QualityAssuranceProfile = lazy(
  () => import("./QualityAssurance/QualityAssuranceProfile")
);
export const Categories = lazy(() => import("./Categories"));
export const Types = lazy(() => import("./Types"));
export const Species = lazy(() => import("./Species"));
export const SpecieProfile = lazy(() => import("./Species/SpeciesProfile"));
export const Objects = lazy(() => import("./Objects"));
export const ObjectProfile = lazy(() => import("./Objects/ObjectProfile"));
export const Tags = lazy(() => import("./Tagging"));
export const NotificationRecipients = lazy(
  () => import("./Notifications/NotificationRecipients")
);
export const AddEditNotification = lazy(
  () => import("./Notifications/AddEditNotification")
);
export const NotificationStatus = lazy(
  () => import("./Notifications/NotificationStatus")
);
export const Reports = lazy(() => import("./Reports"));
export const AddEditReport = lazy(() => import("./Reports/AddEditReport"));
export const SyestemSettings = lazy(() => import("./SyestemSettings"));
export const NotificationCenter = lazy(() => import("./NotificationCenter"));
export const OrganizationProfile = lazy(
  () => import("./Organizations/OrganizationProfile")
);
export const Behaviors = lazy(() => import("./Behaviors"));
export const Conditions = lazy(() => import("./Conditions"));
export const AdminsTracking = lazy(() => import("./AdminsTracking"));
export const MarkerGroups = lazy(() => import("./MarkerGroups"));
export const MarkerStyles = lazy(() => import("./MarkerStyles"));

export const Dashboard = lazy(() => import("view/pages/Dashboard"));
export const ReportsAnalytics = lazy(
  () => import("view/pages/Reports/ReportsAnalytics")
);
export const ReportsProfile = lazy(
  () => import("view/pages/Reports/ReportsProfile")
);
export const ResultObservations = lazy(
  () => import("view/pages/Reports/ResultObservations")
);
export const Imports = lazy(() => import("view/pages/imports"));
export const AddImport = lazy(() => import("view/pages/imports/addImport"));
export const ViewImportsData = lazy(
  () => import("view/pages/imports/viewData")
);
export const RunReport = lazy(() => import("view/pages/Reports/RunReport"));
export const RolesPermissions = lazy(
  () => import("view/pages/RolesPermissions")
);
export const PollsSurveys = lazy(
  () => import("view/pages/PollsAndSurveys/Directory")
);
export const CreateOrEditSurvey = lazy(
  () => import("view/pages/PollsAndSurveys/CreateOrEditSurvey")
);
export const SubmitSurvey = lazy(
  () => import("view/pages/PollsAndSurveys/SubmitSurvey")
);
export const ViewSurveyResults = lazy(
  () => import("view/pages/PollsAndSurveys/SurveyResults")
);
export const PageNotFound = lazy(() => import("view/pages/404"));
export const JoinRequests = lazy(() => import("view/pages/JoinRequests"));
export const Brands = lazy(() => import("view/pages/Brands"));
export const AddEditBrand = lazy(
  () => import("view/pages/Brands/AddEditBrand")
);
export const BrandDetails = lazy(
  () => import("view/pages/Brands/BrandDetails")
);
export const DataPortal = lazy(() => import("view/pages/DataPortal"));
export const QueryInterface = lazy(() => import("view/pages/QueryInterface"));
